module.exports = __webpack_public_path__ + "static/media/peace.5241b75c.svg";